export const TableSkeletonCell = () => <div className="msq-skeleton-text w-[80px] h-4" />;
